import SlWholesaleDiscountSubfamily from '@/models/Sale/SlWholesaleDiscountSubfamily'
import WhSubfamily from '@/models/Warehouse/WhSubfamily'
import axios from 'axios'
import API from '@/services/api/api'
// import axios from 'axios'
// import API from '@/services/api/api'

const fetchWholesaleDiscountsSubfamily = async function(id) {
    try {
        let discountsSubfamily =  await SlWholesaleDiscountSubfamily.where('g_branch_office_id', 1)
        .where('wh_subfamily_id', id)
        .params({'get_all_results':true })
        .get()
        return discountsSubfamily.data
    } catch (error) {
        return error
    }
}

const createWholeSaleDiscounts = async function(arrayDiscounts, id) {
    try {
        let discountSchema = []
        for (let i = 0; i < arrayDiscounts.length; i++) {
            let currentDiscount = {
                    quantity_discount: parseInt(arrayDiscounts[i].quantity),
                    percentage_discount: parseInt(arrayDiscounts[i].discount),
                    unit_price_discount: 0,
                }

            discountSchema.push(currentDiscount)
        }

        let data = {
            wh_subfamily_id: id,
            g_branch_office_id: 1,
            discount_schema: discountSchema,
        }
        
        let wh = new SlWholesaleDiscountSubfamily(data)
        let response = await wh.save()

        return response
    } catch (error) {
        //return error.response.data
        return error
    }
}

const updateWholesaleDiscounts = async function(arrayDiscounts, id) {
    let discountSchema = []
    for (let i = 0; i < arrayDiscounts.length; i++) {
        let currentDiscount = {
                quantity_discount: parseInt(arrayDiscounts[i].quantity),
                percentage_discount: parseInt(arrayDiscounts[i].discount),
                unit_price_discount: 0,
            }

        discountSchema.push(currentDiscount)
    }


    let data = {
        g_branch_office_id: 1, // id sucursal TODO: quitar hard code
        discount_schema: discountSchema,
    }

    try{
        let response = await axios.put(`${API.SL_WHOLESALE_DISCOUNT_SUBFAMILY}/${id}`, data)
        return response.data
    }catch(error){
        return(error)
    }

}


const deleteWholesaleDiscounts = async function(id) {

    let data = {
        g_branch_office_id: 1, // id sucursal TODO: quitar hard code
        discount_schema: [],
    }

    try{
        let response = await axios.put(`${API.SL_WHOLESALE_DISCOUNT_SUBFAMILY}/${id}`, data)
        return response.data
    }catch(error){
        return(error)
    }


}

export default {
    fetchWholesaleDiscountsSubfamily,
    createWholeSaleDiscounts,
    updateWholesaleDiscounts,
    deleteWholesaleDiscounts,
}